/* ORILIS Landing v2 — gallery, countdown, COD form. By EcomWhy. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* ---------- product gallery ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-o-gal]').forEach(function (gal) {
      if (gal.dataset.oBound) return;
      gal.dataset.oBound = '1';
      var track = gal.querySelector('.o-gal__track');
      var slides = Array.prototype.slice.call(track.children);
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-o-gal-thumb]'));
      var counter = gal.querySelector('[data-o-gal-i]');
      var cur = 0;
      function go(i) {
        var n = (i + slides.length) % slides.length;
        var s = slides[n];
        var box = track.getBoundingClientRect(), r = s.getBoundingClientRect();
        track.scrollBy({ left: (r.left + r.width / 2) - (box.left + box.width / 2), behavior: reduce ? 'auto' : 'smooth' });
      }
      function sync() {
        var box = track.getBoundingClientRect(), mid = box.left + box.width / 2, best = 0, d = Infinity;
        slides.forEach(function (s, i) { var r = s.getBoundingClientRect(); var x = Math.abs(r.left + r.width / 2 - mid); if (x < d) { d = x; best = i; } });
        if (best === cur && counter && counter.textContent == best + 1) return;
        cur = best;
        if (counter) counter.textContent = best + 1;
        thumbs.forEach(function (t, i) {
          if (i === best) { t.setAttribute('aria-current', 'true'); t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); }
          else t.removeAttribute('aria-current');
        });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.oGalThumb, 10)); }); });
      var prev = gal.querySelector('[data-o-gal-prev]'), next = gal.querySelector('[data-o-gal-next]');
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      var raf = 0;
      track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); }, { passive: true });
    });
  }

  /* ---------- countdown (only when a real end date is set) ---------- */
  function initCountdown(root) {
    (root || document).querySelectorAll('[data-o-countdown]').forEach(function (bar) {
      var raw = (bar.dataset.oCountdown || '').trim();
      var box = bar.querySelector('.o-cd');
      if (!raw || !box || bar.dataset.oBound) return;
      bar.dataset.oBound = '1';
      var end = new Date(raw.replace(' ', 'T')).getTime();
      if (isNaN(end)) return;
      var el = { d: box.querySelector('[data-d]'), h: box.querySelector('[data-h]'), m: box.querySelector('[data-m]'), s: box.querySelector('[data-s]') };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var left = Math.max(0, end - Date.now());
        if (left <= 0) { box.hidden = true; clearInterval(t); return; }
        box.hidden = false;
        var s = Math.floor(left / 1000);
        el.d.textContent = Math.floor(s / 86400);
        el.h.textContent = pad(Math.floor(s % 86400 / 3600));
        el.m.textContent = pad(Math.floor(s % 3600 / 60));
        el.s.textContent = pad(s % 60);
      }
      var t = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- COD form ---------- */
  function money(cents, cur) {
    var dec = cur === 'TND' ? 3 : 2;
    var v = (cents / 100).toFixed(dec);
    return cur === 'TND' ? v + ' DT' : v + ' ' + cur;
  }
  function initCod(root) {
    (root || document).querySelectorAll('[data-o-cod]').forEach(function (form) {
      if (form.dataset.oBound) return;
      form.dataset.oBound = '1';
      var d = form.dataset;
      var fee = Math.round(parseFloat(d.fee || '0') * 100) || 0;
      var freeFrom = parseInt(d.freeFrom || '0', 10) || 0;
      var cur = d.currency || '';
      var unit = parseInt(d.unit, 10) || 0;
      var out = { sub: form.querySelector('[data-o-sub]'), ship: form.querySelector('[data-o-ship]'), tot: form.querySelector('[data-o-tot]') };
      var err = form.querySelector('[data-o-err]');
      var btn = form.querySelector('button[type="submit"]');

      function qtyInput() { return form.querySelector('input[name="quantity"]:checked') || form.querySelector('input[name="quantity"]'); }
      function totals() {
        var q = qtyInput();
        var qty = q ? parseInt(q.value, 10) || 1 : 1;
        var sub = q && q.dataset.total ? parseInt(q.dataset.total, 10) : unit * qty;
        var ship = freeFrom && qty >= freeFrom ? 0 : fee;
        return { qty: qty, sub: sub, ship: ship, tot: sub + ship };
      }
      function render() {
        var t = totals();
        if (out.sub) out.sub.textContent = money(t.sub, cur);
        if (out.ship) out.ship.textContent = t.ship === 0 ? (d.freeLabel || '0') : money(t.ship, cur);
        if (out.tot) out.tot.textContent = money(t.tot, cur);
      }
      form.addEventListener('change', render);
      render();

      function field(name) { return form.querySelector('[name="' + name + '"]'); }
      function mark(el, bad) { var w = el && el.closest('.o-field'); if (w) w.classList.toggle('is-bad', bad); }
      function cleanPhone(v) {
        var p = (v || '').replace(/\D/g, '');
        if (p.indexOf('216') === 0 && p.length === 11) p = p.slice(3);
        if (p.indexOf('00216') === 0) p = p.slice(5);
        return p;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = field('o_name'), phone = field('o_phone'), gov = field('o_gov'), city = field('o_city'), addr = field('o_addr');
        var problems = [];
        var nv = (name.value || '').trim(); var pv = cleanPhone(phone.value); var av = (addr.value || '').trim();
        mark(name, nv.length < 3); if (nv.length < 3) problems.push(d.errName);
        mark(phone, pv.length !== 8); if (pv.length !== 8) problems.push(d.errPhone);
        mark(gov, !gov.value); if (!gov.value) problems.push(d.errGov);
        mark(addr, av.length < 4); if (av.length < 4) problems.push(d.errAddr);
        if (problems.length) {
          err.textContent = problems[0];
          err.hidden = false;
          var firstBad = form.querySelector('.o-field.is-bad input, .o-field.is-bad select');
          if (firstBad) firstBad.focus();
          return;
        }
        err.hidden = true;
        btn.setAttribute('aria-busy', 'true');

        var t = totals();
        var parts = nv.split(/\s+/);
        var first = parts.shift();
        var last = parts.join(' ') || first;
        var cityV = (city.value || '').trim() || gov.value;
        var q = [];
        function add(k, v) { q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); }
        add('checkout[shipping_address][first_name]', first);
        add('checkout[shipping_address][last_name]', last);
        add('checkout[shipping_address][address1]', av);
        add('checkout[shipping_address][city]', cityV);
        add('checkout[shipping_address][province]', gov.value);
        add('checkout[shipping_address][country]', 'Tunisia');
        add('checkout[shipping_address][phone]', '+216' + pv);
        add('attributes[Téléphone]', '+216' + pv);
        add('attributes[Gouvernorat]', gov.value);
        add('attributes[Source]', 'ORILIS landing COD');
        var abv = document.documentElement.getAttribute('data-o-ab');
        if (abv) add('attributes[A/B test]', abv === 'A' ? 'A (offer)' : 'B (desire)');
        add('note', nv + ' | +216' + pv + ' | ' + gov.value + ' | ' + cityV + ' | ' + av);
        window.location.href = '/cart/' + d.variant + ':' + t.qty + '?' + q.join('&');
      });

      ['o_name', 'o_phone', 'o_gov', 'o_addr'].forEach(function (n) {
        var el = field(n);
        if (el) el.addEventListener('input', function () { mark(el, false); });
      });
    });
  }

  function initAll(root) { initGallery(root); initCountdown(root); initCod(root); }
  ready(function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
